import { NgModule } from '@angular/core';

import { AdultIconComponent } from './adult-icon.component';
import { AmbulanceIconComponent } from './ambulance-icon.component';
import { AntennaIconComponent } from './antenna-icon.component';
import { AppartmentComplexIconComponent } from './appartment-complex-icon.component';
import { AppartmentComplex2IconComponent } from './appatment-complex-2-icon.component';
import { ArrowDownIconComponent } from './arrow-down-icon.component';
import { BabyIconComponent } from './baby-icon.component';
import { BackIconComponent } from './back-icon.component';
import { BanditIconComponent } from './bandit-icon.component';
import { BedIconComponent } from './bed-icon.component';
import { BedsFourIconComponent } from './beds-four-icon.component';
import { BedsTwoIconComponent } from './beds-two-icon.component';
import { BellIconComponent } from './bell-icon.component';
import { BellRingIconComponent } from './bell-ring-icon.component';
import { BodyMassageIconComponent } from './body-massage-icon.component';
import { BookOpenIconComponent } from './book-icon.component';
import { BrokenGlassIconComponent } from './broken-glass-icon.component';
import { BubbleSmileIconComponent } from './bubble-smile-icon.component';
import { BuildingIconComponent } from './building-icon.component';
import { CalendarAlternateIconComponent } from './calendar-alternate-icon.component';
import { CalendarIconComponent } from './calendar-icon.component';
import { CameraIconComponent } from './camera-icon.component';
import { CarDrivingIconComponent } from './car-driving-icon.component';
import { CarIconComponent } from './car-icon.component';
import { CarWheelIconComponent } from './car-wheel-icon.component';
import { CartwheelIconComponent } from './cartwheel-icon.component';
import { CatIconComponent } from './cat-icon.component';
import { AlternateCheckIconComponent } from './check-alternate-icon.component';
import { CheckBadgeIconComponent } from './check-badge-icon.component';
import { CheckCircleIconComponent } from './check-circle-icon.component';
import { CheckIconComponent } from './check-icon.component';
import { ChevronLeftIconComponent } from './chevron-left-icon.component';
import { ChevronRightIconComponent } from './chevron-right-icon.component';
import { ChildIconComponent } from './child-icon.component';
import { CircleIconComponent } from './circle-icon.component';
import { ClockIconComponent } from './clock-icon.component';
import { ConstructionIconComponent } from './construction-icon.component';
import { ContractIconComponent } from './contract-icon.component';
import { CrossCircledIconComponent } from './cross-circled-icon.component';
import { CrossIconComponent } from './cross-icon.component';
import { DoctorIconComponent } from './doctor-icon.component';
import { DoctorsIconComponent } from './doctors-icon.component';
import { DocumentIconComponent } from './document-icon.component';
import { DogIconComponent } from './dog-icon.component';
import { DoorIconComponent } from './door-icon.component';
import { DotIconComponent } from './dot-icon.component';
import { DownloadIconComponent } from './download-icon.component';
import { EarIconComponent } from './ear-icon.component';
import { EarthquakeIconComponent } from './earthquake-icon.component';
import { EditAlternateIconComponent } from './edit-alternate-icon.component';
import { EditIconComponent } from './edit-icon.component';
import { Ellipse1IconComponent } from './ellipse1.component';
import { Ellipse2IconComponent } from './ellipse2.component';
import { EnvelopeIconComponent } from './envelope-icon.component';
import { EyeIconComponent } from './eye-icon.component';
import { FacebookIconComponent } from './facebook-icon.component';
import { FamilyIconComponent } from './family-icon.component';
import { FemaleIconComponent } from './female-icon.component';
import { FileAlternateIconComponent } from './file-alternate-icon.component';
import { FileIconComponent } from './file-icon.component';
import { FilledHouseComponent } from './filled-house-icon.component';
import { FilterLinesComponent } from './filter-lines-icon.component';
import { FireAlarmIconComponent } from './fire-alarm-icon.component';
import { FireIconComponent } from './fire-icon.component';
import { FitnessWeightIconComponent } from './fitness-weight-icon.component';
import { ForbiddenIconComponent } from './forbidden-icon.component';
import { FreeIconComponent } from './free-icon.component';
import { FurcoatIconComponent } from './furcoat-icon.component';
import { GarageIconComponent } from './garage-icon.component';
import { GiftIconComponent } from './gift-icon.component';
import { GlassesIconComponent } from './glasses-icon.component';
import { GlobeArrowIconComponent } from './globe-arrow-icon.component';
import { GlobeIconComponent } from './globe-icon.component';
import { GunIconComponent } from './gun-icon.component';
import { HeadIdeaIconComponent } from './headidea-icon.component';
import { HeadLightIconComponent } from './headlight-icon.component';
import { HealthIconComponent } from './health-icon.component';
import { HelicopterIconComponent } from './helicopter-icon.component';
import { HelpCircleIconComponent } from './help-circle-icon.component';
import { HospitalIconComponent } from './hospital-icon.component';
import { HourglassIconComponent } from './hourglass-icon.component';
import { FlatHouseIconComponent } from './house-flat-icon.component';
import { MinimalistHouseIconComponent } from './house-minimalist-icon.component';
import { SimpleHouseIconComponent } from './house-simple-icon.component';
import { HouseWithBuildingIconComponent } from './house-with-building-icon.component';
import { HouseWithTreeIconComponent } from './house-with-tree-icon.component';
import { ImageIconComponent } from './image-icon.component';
import { ImmatriculationIconComponent } from './immatriculation-icon.component';
import { IndividualIconComponent } from './individual-icon.component';
import { InfoIconComponent } from './info-icon.component';
import { InstagramIconComponent } from './instagram-icon.component';
import { AnimalInsuranceIconComponent } from './insurances-icons/animal-insurance-icon.component';
import { BuildingInsuranceIconComponent } from './insurances-icons/building-insurance-icon.component';
import { BusinessAccidentInsuranceIconComponent } from './insurances-icons/business-accident-insurance-icon.component';
import { BusinessBuildingInsuranceIconComponent } from './insurances-icons/business-building-insurance-icon.component';
import { BusinessCompanyThingsInsuranceIconComponent } from './insurances-icons/business-company-things-insurance-icon.component';
import { BusinessConstructionWarrantyInsuranceIconComponent } from './insurances-icons/business-construction-warranty-icon.component';
import { BusinessCyberInsuranceIconComponent } from './insurances-icons/business-cyber-insurance-icon.component';
import { BusinessFleetInsuranceIconComponent } from './insurances-icons/business-fleet-insurance-icon.component';
import { BusinessHealthInsuranceIconComponent } from './insurances-icons/business-health-insurance-icon.component';
import { BusinessLegalProtectionIconComponent } from './insurances-icons/business-legal-protection-insurance-icon.component';
import { BusinessRcCompanyInsuranceIconComponent } from './insurances-icons/business-rc-company-insurance-icon.component';
import { BusinessRcProfessionalInsuranceIconComponent } from './insurances-icons/business-rc-pro-insurance-icon.component';
import { BusinessRentalIconComponent } from './insurances-icons/business-rental-icon.component';
import { BusinessRetirementInsuranceIconComponent } from './insurances-icons/business-retirement-insurance-icon.component';
import { BusinessTechnicalInstallationInsuranceIconComponent } from './insurances-icons/business-technical-installation-insurance-icon.component';
import { BusinessTransportInsuranceIconComponent } from './insurances-icons/business-transport-insurance-icon.component';
import { ConstructionInsuranceIconComponent } from './insurances-icons/construction-insurance-icon.component';
import { HealthInsuranceIconComponent } from './insurances-icons/health-insurance-icon.component';
import { HouseholdInsuranceIconComponent } from './insurances-icons/household-insurance-icon.component';
import { LegalProtectionInsuranceIconComponent } from './insurances-icons/legal-protection-insurance-icon.component';
import { LifeInsuranceIconComponent } from './insurances-icons/life-insurance-icon.component';
import { MotorVehicleInsuranceIconComponent } from './insurances-icons/motor-vehicle-insurance-icon.component';
import { RentalGuaranteeIconComponent } from './insurances-icons/rental-guarantee-icon.component';
import { ThirdPillarInsuranceIconComponent } from './insurances-icons/third-pillar-insurance-icon.component';
import { TravelInsuranceIconComponent } from './insurances-icons/travel-insurance-icon.component';
import { ValuableObjectInsuranceIconComponent } from './insurances-icons/valuable-object-insurance-icon.component';
import { InvoiceIconComponent } from './invoice-icon.component';
import { JewelryIconComponent } from './jewelry-icon.component';
import { KeyIconComponent } from './key-icon.component';
import { LawBalanceIconComponent } from './law-balance-icon.component';
import { LawGavelIconComponent } from './law-gavel-icon.component';
import { DoubleLayerComponent } from './layer-double-icon.component';
import { SingleLayerComponent } from './layer-single-icon.component';
import { LightBulbComponent } from './light-bulb-icon.component';
import { LightBulbHeadComponent } from './lightbulb-head-icon.component';
import { LightningIconComponent } from './lightning-icon.component';
import { LinkExternalIconComponent } from './link-external-icon.component';
import { LtyLogoIconComponent } from './lty-logo-icon.component';
import { MaleIconComponent } from './male-icon.component';
import { MapPinIconComponent } from './map-pin-icon.component';
import { MenuAlternateIconComponent } from './menu-alternate-icon.component';
import { MenuIconComponent } from './menu-icon.component';
import { MergeIconComponent } from './merge-icon.component';
import { MessageSquareIconComponent } from './message-square-icon.component';
import { MinusIconComponent } from './minus-icon.component';
import { MoneyBillIconComponent } from './money-bill-icon.component';
import { MopIconComponent } from './mop-icon.component';
import { MultipleUsersIconComponent } from './multiple-users-icon.component';
import { NumbersIconComponent } from './numbers-icon.component';
import { PadlockIconComponent } from './padlock-icon.component';
import { PaintingIconComponent } from './painting-icon.component';
import { ParkingIconComponent } from './parking-icon.component';
import { PencilLineIconComponent } from './pencil-line-icon.component';
import { PhoneCallIconComponent } from './phone-call-icon.component';
import { PhoneIconComponent } from './phone-icon.component';
import { PianoIconComponent } from './piano-icon.component';
import { PiggyBankIconComponent } from './piggy-bank-icon.component';
import { PipeIconComponent } from './pipe-icon.component';
import { PlaneIconComponent } from './plane-icon.component';
import { PlusIconComponent } from './plus-icon.component';
import { RefreshIconComponent } from './refresh-icon.component';
import { RepairIconComponent } from './repair-icon.component';
import { RoadIconComponent } from './road-icon.component';
import { SearchIconComponent } from './search-icon.component';
import { SendAlternateIconComponent } from './send-alternate-icon.component';
import { SendIconComponent } from './send-icon.component';
import { ShieldDollarIconComponent } from './shield-dollar-icon.component';
import { ShieldIconComponent } from './shield-icon.component';
import { ShoppingIconComponent } from './shopping-icon.component';
import { SmileIconComponent } from './smile-icon.component';
import { SmileyIconComponent } from './smiley-icon.component';
import { SpacingWidthIconComponent } from './spacing-width-icon.component';
import { StarCircleIconComponent } from './star-circle-icon.component';
import { StarIconComponent } from './star-icon.component';
import { StarIconFilledComponent } from './star-icon-filled.component';
import { StethoscopeIconComponent } from './stethoscope-icon.component';
import { SuitcaseIconComponent } from './suitcase-icon.component';
import { SwitchIconComponent } from './switch-icon.component';
import { SynchronizeArrowsIconComponent } from './synchronize-arrows-icon.component';
import { ThiefIconComponent } from './thief-icon.component';
import { TireIconComponent } from './tire-icon.component';
import { TrashIconComponent } from './trash-icon.component';
import { TriangleIconComponent } from './triangle-icon.component';
import { TromboneIconComponent } from './trombone-icon.component';
import { TwoHousesIconComponent } from './two-houses.component';
import { UmbrellaRainIconComponent } from './umbrella-rain.component';
import { UploadCloudIconComponent } from './upload-cloud-icon.component';
import { UserCircleIconComponent } from './user-circle-icon.component';
import { UserHelpMessageIconComponent } from './user-help-message-icon.component';
import { UserIconComponent } from './user-icon.component';
import { VideoIconComponent } from './video-icon.component';
import { VillaIconComponent } from './villa-icon.component';
import { WalletIconComponent } from './wallet-icon.component';
import { WalletOpenIconComponent } from './wallet-open-icon.component';
import { WhatsappIconComponent } from './whatsapp-icon.component';

@NgModule({
  declarations: [
    AdultIconComponent,
    AlternateCheckIconComponent,
    AmbulanceIconComponent,
    AnimalInsuranceIconComponent,
    AntennaIconComponent,
    AppartmentComplex2IconComponent,
    AppartmentComplexIconComponent,
    AppartmentComplexIconComponent,
    ArrowDownIconComponent,
    BabyIconComponent,
    BackIconComponent,
    BanditIconComponent,
    BedIconComponent,
    BedsFourIconComponent,
    BedsTwoIconComponent,
    BellIconComponent,
    BellRingIconComponent,
    BodyMassageIconComponent,
    BookOpenIconComponent,
    BrokenGlassIconComponent,
    BubbleSmileIconComponent,
    BuildingIconComponent,
    BuildingInsuranceIconComponent,
    BusinessAccidentInsuranceIconComponent,
    BusinessBuildingInsuranceIconComponent,
    BusinessCompanyThingsInsuranceIconComponent,
    BusinessConstructionWarrantyInsuranceIconComponent,
    BusinessCyberInsuranceIconComponent,
    BusinessFleetInsuranceIconComponent,
    BusinessHealthInsuranceIconComponent,
    BusinessLegalProtectionIconComponent,
    BusinessRcCompanyInsuranceIconComponent,
    BusinessRcProfessionalInsuranceIconComponent,
    BusinessRentalIconComponent,
    BusinessRetirementInsuranceIconComponent,
    BusinessTechnicalInstallationInsuranceIconComponent,
    BusinessTransportInsuranceIconComponent,
    CalendarAlternateIconComponent,
    CalendarIconComponent,
    CameraIconComponent,
    CarDrivingIconComponent,
    CarIconComponent,
    CartwheelIconComponent,
    CarWheelIconComponent,
    CatIconComponent,
    CheckBadgeIconComponent,
    CheckCircleIconComponent,
    CheckIconComponent,
    ChevronLeftIconComponent,
    ChevronRightIconComponent,
    ChildIconComponent,
    CircleIconComponent,
    ClockIconComponent,
    ConstructionIconComponent,
    ConstructionInsuranceIconComponent,
    ContractIconComponent,
    CrossCircledIconComponent,
    CrossIconComponent,
    DoctorIconComponent,
    DoctorsIconComponent,
    DocumentIconComponent,
    DogIconComponent,
    DoorIconComponent,
    DotIconComponent,
    DoubleLayerComponent,
    DownloadIconComponent,
    EarIconComponent,
    EarthquakeIconComponent,
    EditAlternateIconComponent,
    EditIconComponent,
    Ellipse1IconComponent,
    Ellipse2IconComponent,
    EnvelopeIconComponent,
    EyeIconComponent,
    FacebookIconComponent,
    FamilyIconComponent,
    FemaleIconComponent,
    FileAlternateIconComponent,
    FileIconComponent,
    FilledHouseComponent,
    FilterLinesComponent,
    FireAlarmIconComponent,
    FireIconComponent,
    FitnessWeightIconComponent,
    FlatHouseIconComponent,
    ForbiddenIconComponent,
    FreeIconComponent,
    FurcoatIconComponent,
    GarageIconComponent,
    GiftIconComponent,
    GlassesIconComponent,
    GlobeArrowIconComponent,
    GlobeIconComponent,
    GunIconComponent,
    HeadIdeaIconComponent,
    HeadLightIconComponent,
    HealthIconComponent,
    HealthInsuranceIconComponent,
    HelicopterIconComponent,
    HelpCircleIconComponent,
    HospitalIconComponent,
    HourglassIconComponent,
    HouseholdInsuranceIconComponent,
    HouseWithBuildingIconComponent,
    HouseWithTreeIconComponent,
    ImageIconComponent,
    ImmatriculationIconComponent,
    IndividualIconComponent,
    InfoIconComponent,
    InstagramIconComponent,
    InvoiceIconComponent,
    JewelryIconComponent,
    KeyIconComponent,
    LawBalanceIconComponent,
    LawGavelIconComponent,
    LegalProtectionInsuranceIconComponent,
    LifeInsuranceIconComponent,
    LightBulbComponent,
    LightBulbHeadComponent,
    LightningIconComponent,
    LinkExternalIconComponent,
    LtyLogoIconComponent,
    MaleIconComponent,
    MapPinIconComponent,
    MenuAlternateIconComponent,
    MenuIconComponent,
    MergeIconComponent,
    MessageSquareIconComponent,
    MinimalistHouseIconComponent,
    MinusIconComponent,
    MoneyBillIconComponent,
    MopIconComponent,
    MotorVehicleInsuranceIconComponent,
    MultipleUsersIconComponent,
    NumbersIconComponent,
    PadlockIconComponent,
    PaintingIconComponent,
    ParkingIconComponent,
    PencilLineIconComponent,
    PhoneCallIconComponent,
    PhoneIconComponent,
    PianoIconComponent,
    PiggyBankIconComponent,
    PipeIconComponent,
    PlaneIconComponent,
    PlusIconComponent,
    RefreshIconComponent,
    RentalGuaranteeIconComponent,
    RepairIconComponent,
    RoadIconComponent,
    SearchIconComponent,
    SendAlternateIconComponent,
    SendIconComponent,
    ShieldDollarIconComponent,
    ShieldIconComponent,
    ShoppingIconComponent,
    SimpleHouseIconComponent,
    SingleLayerComponent,
    SmileIconComponent,
    SmileyIconComponent,
    SpacingWidthIconComponent,
    StarCircleIconComponent,
    StarIconComponent,
    StarIconFilledComponent,
    StethoscopeIconComponent,
    SuitcaseIconComponent,
    SwitchIconComponent,
    SynchronizeArrowsIconComponent,
    ThiefIconComponent,
    ThirdPillarInsuranceIconComponent,
    TireIconComponent,
    TireIconComponent,
    TrashIconComponent,
    TravelInsuranceIconComponent,
    TriangleIconComponent,
    TromboneIconComponent,
    TwoHousesIconComponent,
    UmbrellaRainIconComponent,
    UploadCloudIconComponent,
    UserCircleIconComponent,
    UserHelpMessageIconComponent,
    UserIconComponent,
    ValuableObjectInsuranceIconComponent,
    VideoIconComponent,
    VillaIconComponent,
    WalletIconComponent,
    WalletOpenIconComponent,
    WhatsappIconComponent,
  ],
  exports: [
    AdultIconComponent,
    AlternateCheckIconComponent,
    AmbulanceIconComponent,
    AnimalInsuranceIconComponent,
    AntennaIconComponent,
    AppartmentComplex2IconComponent,
    AppartmentComplexIconComponent,
    AppartmentComplexIconComponent,
    ArrowDownIconComponent,
    BabyIconComponent,
    BackIconComponent,
    BanditIconComponent,
    BedIconComponent,
    BedsFourIconComponent,
    BedsTwoIconComponent,
    BellIconComponent,
    BellRingIconComponent,
    BodyMassageIconComponent,
    BookOpenIconComponent,
    BrokenGlassIconComponent,
    BubbleSmileIconComponent,
    BuildingIconComponent,
    BuildingInsuranceIconComponent,
    BuildingInsuranceIconComponent,
    BusinessAccidentInsuranceIconComponent,
    BusinessBuildingInsuranceIconComponent,
    BusinessCompanyThingsInsuranceIconComponent,
    BusinessConstructionWarrantyInsuranceIconComponent,
    BusinessCyberInsuranceIconComponent,
    BusinessFleetInsuranceIconComponent,
    BusinessHealthInsuranceIconComponent,
    BusinessLegalProtectionIconComponent,
    BusinessRcCompanyInsuranceIconComponent,
    BusinessRcProfessionalInsuranceIconComponent,
    BusinessRentalIconComponent,
    BusinessRetirementInsuranceIconComponent,
    BusinessTechnicalInstallationInsuranceIconComponent,
    BusinessTransportInsuranceIconComponent,
    CalendarAlternateIconComponent,
    CalendarIconComponent,
    CameraIconComponent,
    CarDrivingIconComponent,
    CarIconComponent,
    CarWheelIconComponent,
    CatIconComponent,
    CheckBadgeIconComponent,
    CheckCircleIconComponent,
    CheckIconComponent,
    ChevronLeftIconComponent,
    ChevronRightIconComponent,
    ChildIconComponent,
    CircleIconComponent,
    ClockIconComponent,
    ConstructionIconComponent,
    ConstructionInsuranceIconComponent,
    ContractIconComponent,
    CrossCircledIconComponent,
    CrossIconComponent,
    DoctorIconComponent,
    DoctorsIconComponent,
    DocumentIconComponent,
    DogIconComponent,
    DoorIconComponent,
    DotIconComponent,
    DoubleLayerComponent,
    DownloadIconComponent,
    EarIconComponent,
    EarthquakeIconComponent,
    EditAlternateIconComponent,
    EditIconComponent,
    Ellipse1IconComponent,
    Ellipse2IconComponent,
    EnvelopeIconComponent,
    EyeIconComponent,
    FacebookIconComponent,
    FamilyIconComponent,
    FemaleIconComponent,
    FileAlternateIconComponent,
    FileIconComponent,
    FilledHouseComponent,
    FilterLinesComponent,
    FireAlarmIconComponent,
    FireIconComponent,
    FitnessWeightIconComponent,
    FlatHouseIconComponent,
    ForbiddenIconComponent,
    FreeIconComponent,
    FurcoatIconComponent,
    GarageIconComponent,
    GiftIconComponent,
    GlassesIconComponent,
    GlobeArrowIconComponent,
    GlobeIconComponent,
    GunIconComponent,
    HeadIdeaIconComponent,
    HeadLightIconComponent,
    HealthIconComponent,
    HealthInsuranceIconComponent,
    HelicopterIconComponent,
    HelpCircleIconComponent,
    HospitalIconComponent,
    HourglassIconComponent,
    HouseholdInsuranceIconComponent,
    HouseWithBuildingIconComponent,
    HouseWithTreeIconComponent,
    ImageIconComponent,
    ImmatriculationIconComponent,
    IndividualIconComponent,
    InfoIconComponent,
    InstagramIconComponent,
    InvoiceIconComponent,
    JewelryIconComponent,
    KeyIconComponent,
    LawBalanceIconComponent,
    LawGavelIconComponent,
    LegalProtectionInsuranceIconComponent,
    LifeInsuranceIconComponent,
    LightBulbComponent,
    LightBulbHeadComponent,
    LightningIconComponent,
    LinkExternalIconComponent,
    LtyLogoIconComponent,
    MaleIconComponent,
    MapPinIconComponent,
    MenuAlternateIconComponent,
    MenuIconComponent,
    MergeIconComponent,
    MessageSquareIconComponent,
    MinimalistHouseIconComponent,
    MinusIconComponent,
    MoneyBillIconComponent,
    MopIconComponent,
    MotorVehicleInsuranceIconComponent,
    MultipleUsersIconComponent,
    NumbersIconComponent,
    PadlockIconComponent,
    PaintingIconComponent,
    ParkingIconComponent,
    PencilLineIconComponent,
    PhoneCallIconComponent,
    PhoneIconComponent,
    PianoIconComponent,
    PiggyBankIconComponent,
    PipeIconComponent,
    PlaneIconComponent,
    PlusIconComponent,
    RefreshIconComponent,
    RentalGuaranteeIconComponent,
    RepairIconComponent,
    RoadIconComponent,
    SearchIconComponent,
    SendAlternateIconComponent,
    SendIconComponent,
    ShieldDollarIconComponent,
    ShieldIconComponent,
    ShoppingIconComponent,
    SimpleHouseIconComponent,
    SingleLayerComponent,
    SmileIconComponent,
    SmileyIconComponent,
    SpacingWidthIconComponent,
    StarCircleIconComponent,
    StarIconComponent,
    StarIconFilledComponent,
    StethoscopeIconComponent,
    SuitcaseIconComponent,
    SwitchIconComponent,
    SynchronizeArrowsIconComponent,
    ThiefIconComponent,
    ThirdPillarInsuranceIconComponent,
    TireIconComponent,
    TireIconComponent,
    TrashIconComponent,
    TravelInsuranceIconComponent,
    TriangleIconComponent,
    TromboneIconComponent,
    TwoHousesIconComponent,
    UmbrellaRainIconComponent,
    UploadCloudIconComponent,
    UserCircleIconComponent,
    UserHelpMessageIconComponent,
    UserIconComponent,
    ValuableObjectInsuranceIconComponent,
    VideoIconComponent,
    VillaIconComponent,
    WalletIconComponent,
    WalletOpenIconComponent,
    WhatsappIconComponent,
  ],
})
export class IconsModule {}
